import React from 'react';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { StatusSelect } from '../common';
import { BLOCKED_STATUS_DISPLAY, TALK_STATUS_DISPLAY, TEST_ACCOUNT_STATUS_DISPLAY } from '../../types/nurse';

interface NormalSearchFieldsProps {
  talkStatus: string;
  onTalkStatusChange: (event: SelectChangeEvent) => void;
  blockedStatus: string;
  onBlockedStatusChange: (event: SelectChangeEvent) => void;
  conversationCount: string;
  onConversationCountChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  conversationCountOperator: string;
  onConversationCountOperatorChange: (event: SelectChangeEvent) => void;
  testAccountStatus: string;
  onTestAccountStatusChange: (event: SelectChangeEvent) => void;
}

/**
 * 通常看護師検索用のフィールド
 */
const NormalSearchFields: React.FC<NormalSearchFieldsProps> = ({
  talkStatus,
  onTalkStatusChange,
  blockedStatus,
  onBlockedStatusChange,
  conversationCount,
  onConversationCountChange,
  conversationCountOperator,
  onConversationCountOperatorChange,
  testAccountStatus,
  onTestAccountStatusChange
}) => {
  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {/* 対話状態 */}
      <Grid item xs={12} md={3}>
        <StatusSelect
          label="対話状態"
          id="talk-status-filter"
          value={talkStatus}
          onChange={onTalkStatusChange}
          options={TALK_STATUS_DISPLAY}
        />
      </Grid>

      {/* 対話回数 */}
      <Grid item xs={12} md={3}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
          {/* 回数入力 */}
          <TextField
            size="small"
            label="対話回数"
            placeholder="例: 5"
            variant="outlined"
            value={conversationCount}
            onChange={onConversationCountChange}
            type="text"
            inputProps={{
              pattern: '[0-9]*',
              inputMode: 'numeric',
              style: { textAlign: 'center' }
            }}
            sx={{ width: '50%', mr: 1 }}
          />

          {/* 演算子選択 - 回数が入力されたら有効化/文字濃く */}
          <FormControl size="small" sx={{ width: '50%' }}>
            <InputLabel
              id="conversation-count-operator-label"
              sx={{
                color: conversationCount ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.38)'
              }}
            >
              回数条件
            </InputLabel>
            <Select
              labelId="conversation-count-operator-label"
              id="conversation-count-operator"
              value={conversationCountOperator}
              onChange={onConversationCountOperatorChange}
              label="回数条件"
              fullWidth
              disabled={!conversationCount}
              sx={{
                '& .MuiSelect-select': {
                  color: conversationCount ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.38)'
                }
              }}
            >
              <MenuItem value="eq">と等しい</MenuItem>
              <MenuItem value="gte">以上</MenuItem>
              <MenuItem value="lte">以下</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Grid>

      {/* テストアカウント */}
      <Grid item xs={12} md={3}>
        <StatusSelect
          label="テストアカウント"
          id="test-account-filter"
          value={testAccountStatus}
          onChange={onTestAccountStatusChange}
          options={TEST_ACCOUNT_STATUS_DISPLAY}
        />
      </Grid>

      {/* 対話拒否 */}
      <Grid item xs={12} md={3}>
        <StatusSelect
          label="対話拒否状態"
          id="blocked-status-filter"
          value={blockedStatus}
          onChange={onBlockedStatusChange}
          options={BLOCKED_STATUS_DISPLAY}
        />
      </Grid>
    </Grid>
  );
};
export default NormalSearchFields;
